$(function() {

  $('.updateFilters').on('click', updateFilters);
  $('.clearFilters').on('click', clearFilters);

  function clearFilters() {
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.delete('sport_ids');
    searchParams.delete('team_ids');
    searchParams.delete('platform_platform_ids');
    searchParams.delete('platform_category_ids');
    searchParams.delete('project_category_ids');
    searchParams.delete('offer_category_ids');
    searchParams.delete('event_category_ids');
    searchParams.delete('article_category_ids');
    searchParams.delete('industries');
    searchParams.delete('activities');
    searchParams.delete('conference_ids');
    searchParams.delete('collective_ids');
    searchParams.delete('agency_ids');
    searchParams.delete('countries');
    searchParams.delete('states');
    searchParams.delete('accolade_ids');
    searchParams.delete('degree_ids');
    searchParams.delete('twitter_followers');
    searchParams.delete('instagram_followers');
    searchParams.delete('twitch_followers');
    searchParams.delete('facebook_followers');
    searchParams.delete('youtube_followers');
    searchParams.delete('tiktok_followers');
    searchParams.delete('athlete_status_ids');
    searchParams.delete('service_category_ids');
    searchParams.delete('service_provider_categories');
    searchParams.delete('sport_levels');
    searchParams.delete('marketplace_price');
    searchParams.delete('marketplace_category_ids');
    searchParams.delete('stories_sports');
    searchParams.delete('stories_teams');
    searchParams.delete('stories_agencys');
    searchParams.delete('stories_collectives');
    searchParams.delete('stories_conferences');
    searchParams.delete('former_athletes');

    window.location.search = searchParams.toString();
  }

  function updateFilters(event){
    const checkedboxes = $(`.filter-option`);

    const desiredFilters = checkedboxes.toArray().reduce((map, input) => {

      if (
        (input.type === 'checkbox' && input.checked === false) ||
        (input.type === 'range' && (!input.value || input.value === "0")) ||
        (input.type === 'select-one' && input.value === "")
      ) {
        return map;
      }

      map[input.name] = map[input.name] || []
      map[input.name].push(input.value)

      return map
    }, {})

    const existingSearchParams = new URLSearchParams(window.location.search);
    const newSearchParams = new URLSearchParams();

    Object.keys(desiredFilters).forEach(key => {
      newSearchParams.set(key, desiredFilters[key]);
    })

    // keep the tab
    if (existingSearchParams.get('tab')) {
      newSearchParams.set('tab', existingSearchParams.get('tab'))
    }

    // keep the category (for services)
    if (existingSearchParams.get('category')) {
      newSearchParams.set('category', existingSearchParams.get('category'))
    }

    window.location.search = newSearchParams.toString();
  }

  function updateFilterCountUI() {
    const checkedboxes = $(`.filter-option:checked`);
    const selected = $(`select.filter-option`).filter(function() { return $(this).val() });
    const ranges = $(`.filter-option[type=range]`).filter( function() { return $(this).val() !== "0"; })

    const count = checkedboxes.length + selected.length + ranges.length;

    if (count) {
      $("#filter-count").text(count.toString());
    }
  }

  updateFilterCountUI();

  $(".filter-slider").on('input', function(event) {
    $(`#range_value_${event.target.dataset.platformId}`).text(event.target.value);
  });

});
